export default function Break() {
    return <div className={'break'}> </div>
}
